const nuxtPublicPath = '/__nuxt-public'

export const useParsePublicUrls = () => {
  const runtimeConfig = useRuntimeConfig()
  const cdnURL = runtimeConfig.app.cdnURL
  const parsePublicUrls = (url: string): string => {
    if (!cdnURL) {
      return url
    }

    if (!url.startsWith(nuxtPublicPath)) {
      return url
    }

    return `${cdnURL}${url}`
  }
  return { parsePublicUrls }
}
